import React from 'react'
import { Outlet } from 'react-router-dom'

function AuthLayout() {
    return (
        <>
            {/* strat content */}
            <div className="flex flex-row justify-center items-center bg-gray-100 md:mt-16 p-6 w-full h-screen">

                <Outlet />

            </div>
            {/* end content */}
        </>
    )
}

export default AuthLayout